import { render, staticRenderFns } from "./TabellaNotifiche.vue?vue&type=template&id=060d3ebf&scoped=true"
import script from "./TabellaNotifiche.vue?vue&type=script&lang=js"
export * from "./TabellaNotifiche.vue?vue&type=script&lang=js"
import style0 from "./TabellaNotifiche.vue?vue&type=style&index=0&id=060d3ebf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "060d3ebf",
  null
  
)

export default component.exports